<div class="ui-g" id="infobaseRuleForm">
  <div class="ui-g-8 padding20">


    <div class="ui-g-12 ui-md-10 flex-align-center">
      <div class="ui-g-12 ui-md-4">
        <label class="top-label" [ngClass]="{'required': true}">{{ 'audit.typeRule' | translate }}</label>
        <div>
          <p-dropdown #type_rule [style]="{'width':'80%'}" [options]="actionsRulesTypeCombo" [filter]="false"
            [(ngModel)]="selectedRule" [disabled]="readOnly || (auditRuleObject && auditRuleObject.rule && auditRuleObject.rule.id>0)"
            placeholder="{{'common.select_something' | translate}}" (onChange)="loadJsonSchemaCreate($event.value)">
          </p-dropdown>
          <!--          <app-form-fields #rule_type
          [fieldSchema]="formSchema.form.rule_type"
          [(fieldModel)]="fieldModel.rule_type"
          [type]="'dropdown'"
          [options]="actionsRulesTypeCombo"
          [optionLabel]="'label'"
          [placeholder]="'common.select_something' | translate"
          (fieldModelChange)="loadJsonSchema($event)"
          [label]="'audit.ruleType' | translate"
          [required]="true" [disabled]="readOnly" [(fieldModel)]="fieldModel.rule_type">
        </app-form-fields>-->
        </div>
      </div>

      <div class="ui-g-12 ui-md-4">
        <label class="top-label" for="sorg_event">{{ 'audit.sorgEventRule' | translate }}</label>
        <div>
          <input style="color:#898989;" name="sorg_event" [(ngModel)]="sorgEvent" #sorg_event type="text" pInputText
            disabled="true" />
        </div>
      </div>

      <div class="ui-g-12 ui-md-4">
        <label class="top-label required" for="rule_code">{{ 'audit.codeRule' | translate }}</label>
        <div>
          <input name="rule_code" #rule_code type="text" pInputText required [disabled]="readOnly" />
        </div>
      </div>
    </div>

    <div class="ui-g-12 ui-md-10 flex-align-center">

      <div class="ui-g-12 ui-md-4">
        <label class="top-label required" for="desc_rule">{{ 'audit.descrRule' | translate }}</label>
        <div>
          <input name="desc_rule" #desc_rule type="text" pInputText required [disabled]="readOnly" />
        </div>
      </div>

      <div class="ui-g-12 ui-md-4">
        <label class="top-label required" for="start_val_rule">{{ 'audit.startDateRule' | translate }}</label>
        <div>
          <app-kv-calendar #start_val_rule [formData]="dateRangeForm" [inputName]="'date_start'"
            [startDateSelector]="true" [endDateInputName]="'date_end'"
            [endDateCalendar]="end_val_rule" [disabled]="readOnly"></app-kv-calendar>
        </div>
      </div>
      <div class="ui-g-12 ui-md-4">
        <label class="top-label required" for="end_val_rule">{{ 'audit.endDateRule' | translate }}</label>
        <div>
          <app-kv-calendar #end_val_rule [formData]="dateRangeForm" [inputName]="'date_end'" [startDateSelector]="true"
            [endDateInputName]="'date_end'" [startDateCalendar]="start_val_rule" [endDateCalendar]="end_val_rule" [disabled]="readOnly">
          </app-kv-calendar>
        </div>
      </div>
    </div>


  </div>


  <h3 class="ui-g-12" style="color: #20417b;"
    *ngIf="fieldModel.cluster || (formSchema && formSchema.form && formSchema.form.cluster)">{{ ruleTypeTitle }}</h3>
  <div class="ui-g-12 ui-md-10 flex-align-center" id="clusterBase"
    *ngIf="fieldModel.cluster || (formSchema && formSchema.form && formSchema.form.cluster)">
    <div class="ui-g-12 ui-md-4">
        <app-form-fields #cluster  *ngIf="formSchema"
          [fieldSchema]="formSchema.form.cluster"
          [(fieldModel)]="fieldModel.cluster"
          [options]="effectiveClusterOption"
          [filterable]="true"
          [optionLabel]="'label'"
        [placeholder]="'audit.select_cluster' | translate">
      </app-form-fields>
    </div>
  </div>


  <h3 class="ui-g-12" *ngIf="fieldModel.acm || (formSchema && formSchema.form && formSchema.form.acm)">{{ ruleTypeTitle
    }}</h3>
  <div class="ui-g-12 ui-md-10 flex-align-center" id="acmBase"
    *ngIf="fieldModel.acm || (formSchema && formSchema.form && formSchema.form.acm)">

    <!-- Prima riga -->
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #acm *ngIf="formSchema" [fieldSchema]="formSchema.form.acm" [(fieldModel)]="fieldModel.acm"
          [options]="acmList" [filterable]="true" [optionLabel]="'label'"
          [placeholder]="'audit.selectAcm' | translate">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-4" style="margin-top: 1%; text-align: center !important;">
        <app-form-fields #acm_active_range *ngIf="formSchema" [fieldSchema]="formSchema.form.acm_active_range"
          [(fieldModel)]="fieldModel.acm_active_range" [optionLabel]="'label'"
          (checkboxChanged)="onChangeAcmRange($event)" [placeholder]="'audit.select_acm_active_range' | translate">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-2">
        <app-form-fields #acm_min *ngIf="fieldModel.acm_active_range" [fieldSchema]="formSchema.form.acm_min"
          [(fieldModel)]="fieldModel.acm_min">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-2">
        <app-form-fields #acm_max *ngIf="fieldModel.acm_active_range" [fieldSchema]="formSchema.form.acm_max"
          [(fieldModel)]="fieldModel.acm_max">
        </app-form-fields>
      </div>
    </div>

    <!-- Nuova riga -->
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #rule_challenge *ngIf="formSchema && (formSchema.form.rule_challenge || fieldModel.rule_challenge)"
          [fieldSchema]="formSchema.form.rule_challenge" [(fieldModel)]="fieldModel.rule_challenge"
          [optionLabel]="'label'" [options]="filteredChallengeList || challengeListFull" [filterable]="true"
          (fieldModelChange)="onChangeChallenge($event)" [placeholder]="'audit.select_rule_challenge' | translate"
          [disabled]="readOnly || (formSchema && formSchema.form && formSchema.form.rule_challenge && formSchema.form.rule_challenge.disabled) || (!(dateRangeForm?.get('date_start')?.value && dateRangeForm?.get('date_end')?.value))">
        </app-form-fields>
      </div>
      <div class="ui-g-12 ui-md-4">
        <app-form-fields #rule_challenge_detail
          *ngIf="formSchema && ((challengeDetailList.length > 0) || fieldModel.rule_challenge_detail)"
          [fieldSchema]="formSchema.form.rule_challenge_detail" [(fieldModel)]="fieldModel.rule_challenge_detail"
          [optionLabel]="'label'" [options]="challengeDetailList" [filterable]="true"
          (fieldModelChange)="onChangeChallengeDetail($event)"
          [placeholder]="'audit.select_rule_challenge_detail' | translate"
          [disabled]="readOnly || (formSchema && formSchema.form && formSchema.form.rule_challenge_detail && formSchema.form.rule_challenge_detail.disabled) || !fieldModel.rule_challenge">
        </app-form-fields>
      </div>
    </div>

  </div>

  <h3 class="ui-g-12" *ngIf="fieldModel.anag || (formSchema && formSchema.form && formSchema.form.anag)">{{
    ruleTypeTitle }}</h3>
  <div class="ui-g-12 ui-md-10 flex-align-center" id="anagBase"
    *ngIf="fieldModel.anag || (formSchema && formSchema.form && formSchema.form.anag)">

    <div class="ui-g-12 ui-md-4">
      <app-form-fields #cinfo_nominativo [readOnly]="readOnly" [fieldSchema]="formSchema.form.cinfo_nominativo"
        [(fieldModel)]="fieldModel.cinfo_nominativo">
      </app-form-fields>
    </div>
    <div class="ui-g-12 ui-md-4">
      <app-form-fields #cinfo_blacklist [fieldSchema]="formSchema.form.cinfo_blacklist"
        [(fieldModel)]="fieldModel.cinfo_blacklist">
      </app-form-fields>
    </div>
    <div class="ui-g-12 ui-md-4">
      <app-form-fields #cinfo_newsletter [fieldSchema]="formSchema.form.cinfo_newsletter"
        [(fieldModel)]="fieldModel.cinfo_newsletter">
      </app-form-fields>
    </div>
    <div class="ui-g-12 ui-md-4">
      <app-form-fields #cinfo_recapiti [fieldSchema]="formSchema.form.cinfo_recapiti"
        [(fieldModel)]="fieldModel.cinfo_recapiti">
      </app-form-fields>
    </div>
    <div class="ui-g-12 ui-md-4">
      <app-form-fields #cinfo_privacy [fieldSchema]="formSchema.form.cinfo_privacy"
        [(fieldModel)]="fieldModel.cinfo_privacy">
      </app-form-fields>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-rule-base/audit-rule-base.component.html